import CustomModalLayoutV2 from "../../../bidder/Tabs/auctionFloor/components/CustomModalLayoutV2";
import { PDViewAuthorisedOfficerPopupActionButtonGroup } from "./PDViewAuthorisedOfficerPopupActionButtonGroup";
import React, { useMemo } from "react";
import { ButtonStatesInterface } from "./PropertyDocumentViewListItem";
import { RequestCallbackViaType } from "./PDContactAuthorisedOfficer";

export interface NewContactDetails {
  contact_names?: string;
  contact_mobiles?: string;
  contact_emails?: string;
}

export interface OldContactDetails {
  contact?: string;
}

export interface PDViewAuthorisedOfficerPopupModalProps {
  open: boolean;
  contactDetails?: {
    contact_names?: string;
    contact_mobiles?: string;
    contact_emails?: string;
    contact?: string;
  };
  onRequestContactDetailsButtonClick: () => void;
  onWhatsAppButtonClick?: () => void;
  showWhatsAppButton?: boolean;
  onClose?: () => void;
  title?: string;
  requestCallbackButtonStates: ButtonStatesInterface;
  whatsAppButtonStates?: ButtonStatesInterface;
  setRequestCallbackVia: React.Dispatch<
    React.SetStateAction<RequestCallbackViaType>
  >;
}

export const PDViewAuthorisedOfficerPopupModal: React.FC<
  PDViewAuthorisedOfficerPopupModalProps
> = ({
  open,
  contactDetails,
  showWhatsAppButton = false,
  onClose = () => {},
  title = "Authorised Officer Details",
  requestCallbackButtonStates = {
    processing: false,
    error: false,
    success: false,
  },
  onRequestContactDetailsButtonClick = () => {},
  onWhatsAppButtonClick = () => {},
  whatsAppButtonStates = { processing: false, error: false, success: false },
  setRequestCallbackVia = () => {},
}) => {
  const isContactDetailsExists = useMemo(() => {
    return (
      (contactDetails?.contact_mobiles && contactDetails?.contact_names) ||
      contactDetails?.contact
    );
  }, [contactDetails]);

  return (
    <CustomModalLayoutV2
      open={open}
      blurBackground
      onClose={onClose}
      childrenClassName="pb-6 px-6"
      className="pt-8 mx-4 w-full md:w-[400px]"
    >
      <h2 className="text-xl font-semibold text-[#222] font-[Inter, Arial, sans-serif]">
        {title}
      </h2>

      <div className="py-4 px-2">
        <div className="space-y-3">
          <ContactDetailsView
            newContactDetails={{
              contact_names: contactDetails?.contact_names,
              contact_mobiles: contactDetails?.contact_mobiles,
              contact_emails: contactDetails?.contact_emails,
            }}
            oldContactDetails={{
              contact: contactDetails?.contact,
            }}
          />
          <div className="pt-2 border-t border-[#eee] text-[0.85rem] text-[#555] font-[Inter, Arial, sans-serif]">
            For assistance related to this property or the auction process, you
            may connect with AuctionBazaar support.
          </div>
          <div className="space-y-3">
            <PDViewAuthorisedOfficerPopupActionButtonGroup
              showWhatsAppButton={showWhatsAppButton}
              onRequestContactDetailsButtonClick={
                onRequestContactDetailsButtonClick
              }
              onWhatsAppButtonClick={onWhatsAppButtonClick}
              requestCallbackButtonStates={requestCallbackButtonStates}
              whatsAppButtonStates={whatsAppButtonStates}
              setRequestCallbackVia={setRequestCallbackVia}
            />
            <div className="text-[0.75rem] text-[#666] pt-2">
              Available Mon - Sat | 10:00 AM - 6:00 PM
            </div>
          </div>
        </div>
        <div className="pt-3">
          {isContactDetailsExists ? (
            <div className="text-[0.7rem] text-[#777] leading-5 font-[Inter, Arial, sans-serif]">
              Support is provided for general guidance and process-related
              assistance. All auction-related decisions remain subject to the
              respective bank or authorised officer.
            </div>
          ) : (
            <p className="text-[0.9rem] text-[#333] font-[Inter, Arial, sans-serif]">
              Authorized Officer details are currently not available for this
              property. For guidance related to the auction process or next
              steps, you may connect with the AuctionBazaar support team.
            </p>
          )}
        </div>
      </div>
    </CustomModalLayoutV2>
  );
};

const InlineLabelValue = ({
  title,
  value,
}: {
  title: string;
  value: string;
}) => {
  return (
    <p className="text-[0.9rem] text-[#333] font-[Inter, Arial, sans-serif]">
      <span className="font-semibold">{title}: </span>
      {value || "N/A"}
    </p>
  );
};

const ContactDetailsView = ({
  newContactDetails,
  oldContactDetails,
}: {
  newContactDetails: NewContactDetails;
  oldContactDetails: OldContactDetails;
}) => {
  return (
    <div>
      {newContactDetails?.contact_mobiles &&
      newContactDetails?.contact_names ? (
        <>
          <InlineLabelValue
            title="Name"
            value={newContactDetails?.contact_names || "N/A"}
          />
          <InlineLabelValue
            title="Contact"
            value={newContactDetails?.contact_mobiles || "N/A"}
          />
          {newContactDetails?.contact_emails && (
            <InlineLabelValue
              title="Email"
              value={newContactDetails?.contact_emails || "N/A"}
            />
          )}
        </>
      ) : null}
      {oldContactDetails?.contact ? (
        <InlineLabelValue
          title="Contact Details"
          value={oldContactDetails?.contact}
        />
      ) : null}
    </div>
  );
};
